var _title, _title2, _title3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSubscriptionStatusActive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "235.874 208.973 184.748 220.487",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: -251.192,
    y1: 236.904,
    x2: -251.192,
    y2: 288.039,
    id: "gradient-0",
    gradientTransform: "matrix(-0.579857, -0.814718, 0.616757, -0.438963, -535.698456, 171.789763)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgba(181, 129, 8, 1)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgba(84, 60, 4, 1)"
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 235.874,
    y: 208.973,
    width: 184.748,
    height: 220.487,
    rx: 2,
    ry: 2,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(1, 0, 0, 1, 526.0029296875, -143.87876892089844)"
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Card")), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 6,
      fill: "rgba(49, 49, 49, 0.22)"
    },
    x: -286.482,
    y: 384.148,
    width: 158.744,
    height: 185.369,
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 6,
      stroke: "rgb(175, 88, 17)",
      paintOrder: "fill",
      fill: "rgb(236, 90, 12)"
    },
    x: -280.318,
    y: 374.082,
    width: 158.744,
    height: 185.369,
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: -267.14,
    y: 513.007,
    width: 50.082,
    height: 34.228,
    rx: 2,
    ry: 2,
    style: {
      fill: "rgb(241, 180, 147)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(216, 216, 216)",
      strokeWidth: 8,
      strokeLinecap: "round",
      stroke: "rgb(241, 180, 147)"
    },
    d: "M -202.284 540.727 L -139.383 540.695"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 8,
      strokeLinecap: "round",
      fill: "none",
      stroke: "rgb(241, 180, 147)"
    },
    d: "M -262.707 444.777 L -139.384 444.762"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 8,
      strokeLinecap: "round",
      fill: "none",
      stroke: "rgb(241, 180, 147)"
    },
    d: "M -262.326 455.715 L -139.003 455.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 8,
      strokeLinecap: "round",
      fill: "none",
      stroke: "rgb(241, 180, 147)"
    },
    d: "M -262.255 470.653 L -257.995 470.638"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 8,
      strokeLinecap: "round",
      fill: "none",
      stroke: "rgb(241, 180, 147)"
    },
    d: "M -262.242 481.12 L -257.982 481.105"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 8,
      strokeLinecap: "round",
      fill: "none",
      stroke: "rgb(241, 180, 147)"
    },
    d: "M -245.77 470.73 L -139.917 470.715"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 8,
      strokeLinecap: "round",
      fill: "none",
      stroke: "rgb(241, 180, 147)"
    },
    d: "M -245.443 481.197 L -139.59 481.182"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 8,
      strokeLinecap: "round",
      fill: "none",
      stroke: "rgb(241, 180, 147)"
    },
    d: "M -262.011 491.587 L -257.751 491.572"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 8,
      strokeLinecap: "round",
      fill: "none",
      stroke: "rgb(241, 180, 147)"
    },
    d: "M -245.212 491.664 L -139.359 491.649"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 8,
      strokeLinecap: "round",
      fill: "none",
      stroke: "rgb(241, 180, 147)"
    },
    d: "M -262.011 502.054 L -257.751 502.039"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 8,
      strokeLinecap: "round",
      fill: "none",
      stroke: "rgb(241, 180, 147)"
    },
    d: "M -245.212 502.131 L -139.359 502.116"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -226.192,
    y: 393.429,
    width: 50.082,
    height: 34.228,
    rx: 2,
    ry: 2,
    style: {
      fill: "rgb(241, 180, 147)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "matrix(0.9276170134544373, 0, 0, 0.9276170134544373, 283.6766662597656, 241.01834106445312)",
    style: {}
  }, _title2 || (_title2 = /*#__PURE__*/React.createElement("title", null, "Pen")), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0.122058,
      fill: "rgb(119, 57, 7)"
    },
    d: "m 91.595948,159.70025 c 0.210061,-0.17767 0.801847,-0.67036 1.315088,-1.09483 0.513252,-0.4245 1.188308,-0.99049 1.50015,-1.25776 1.713237,-1.46845 2.925055,-2.42311 3.075828,-2.42311 0.22492,0 0.690667,-0.56752 0.690667,-0.84159 0,-0.42062 -0.290259,-0.81461 -0.692772,-0.9403 -0.519097,-0.16213 -0.966305,0.0177 -1.203792,0.4844 -0.263769,0.51819 -5.179133,6.20385 -5.232469,6.05243 -0.02566,-0.0727 0.01195,-0.19895 0.08356,-0.28057 0.220117,-0.25099 1.354432,-2.70287 1.685748,-3.64384 0.440498,-1.25105 0.808821,-2.73652 0.971392,-3.9177 0.07643,-0.5551 0.205742,-1.072 0.287433,-1.14867 0.08169,-0.0767 1.332086,-0.83855 2.778681,-1.69304 l 2.630171,-1.55364 0.694827,0.63195 c 2.74966,2.50082 3.76885,3.46533 3.76885,3.56659 0,0.0643 -0.16053,0.36176 -0.35677,0.66135 -0.19623,0.2996 -0.91612,1.46532 -1.59976,2.59051 -1.18381,1.94842 -1.26388,2.04903 -1.68213,2.11389 -3.342783,0.51845 -5.83777,1.31339 -8.153692,2.59786 -0.913935,0.50691 -1.080464,0.53542 -0.56105,0.0961 z m 10.975792,-11.05989 -2.94601,-2.7127 1.50168,-1.8837 c 4.98235,-6.2498 8.74219,-10.7535 12.16739,-14.57467 1.10536,-1.23311 2.10405,-2.3536 2.21933,-2.48994 0.20814,-0.24617 0.21469,-0.2434 0.94104,0.39701 0.40229,0.35469 2.25591,2.04234 4.11916,3.75034 1.86324,1.708 3.62769,3.30844 3.92098,3.55654 0.29329,0.24811 0.53324,0.51978 0.53324,0.60371 0,0.17503 -3.32185,3.08988 -6.90091,6.05538 -3.29226,2.72786 -12.4105,10.02127 -12.52129,10.01542 -0.0487,-0.003 -1.4143,-1.22541 -3.03461,-2.71739 z m 21.75005,-16.06061 c -1.09274,-1.00005 -2.91937,-2.67575 -4.05913,-3.72377 -1.13975,-1.04802 -2.41106,-2.20793 -2.82511,-2.57759 l -0.75283,-0.6721 1.00377,-0.97196 c 4.43701,-4.29636 8.35549,-7.82836 11.97397,-10.79295 0.43839,-0.35917 0.91609,-0.75321 1.06154,-0.8756 0.49894,-0.41988 5.03227,-3.8261 6.03613,-4.53537 1.93505,-1.36723 3.07685,-2.08633 3.25248,-2.0484 0.24951,0.054 1.70364,1.38998 1.70364,1.56535 0,0.13378 -1.3593,1.59157 -4.38867,4.70665 -0.66685,0.68571 -2.44848,2.52911 -3.9592,4.09644 -1.51074,1.56734 -2.98096,3.09015 -3.2672,3.38401 -2.88114,2.9581 -3.96505,4.13681 -4.03028,4.3828 -0.10119,0.38175 0.18898,0.8577 0.65121,1.06795 0.32833,0.14934 0.40979,0.14307 0.77335,-0.0595 0.22351,-0.12446 1.52461,-1.26822 2.89136,-2.54168 8.8699,-8.2644 13.74809,-12.76428 13.83741,-12.76428 0.18508,0 1.75804,1.49937 1.75804,1.6758 0,0.26664 -3.11876,4.56661 -4.89338,6.74673 -0.64116,0.78767 -3.90031,4.6074 -4.00847,4.69796 -0.0391,0.0327 -0.3811,0.4065 -0.76021,0.83078 -0.72226,0.80824 -0.79073,0.88226 -2.58134,2.79071 -1.69857,1.81037 -6.5401,6.68214 -7.17603,7.22084 -0.24994,0.21173 -0.28726,0.18505 -2.24105,-1.60295 z m 19.47558,-24.49154 -2.62406,-2.41957 0.42831,-0.2472 c 2.02742,-1.17013 5.37065,0.72567 5.59789,3.17429 0.0687,0.73951 -0.28485,1.83971 -0.60619,1.88683 -0.0945,0.0139 -1.35273,-1.0636 -2.79595,-2.39435 z",
    id: "path24"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(0.3997590243816376, 0, 0, 0.3997590243816376, 491.9505310058594, 134.1978759765625)"
  }, _title3 || (_title3 = /*#__PURE__*/React.createElement("title", null, "Status Paid")), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 6,
      fill: "rgba(49, 49, 49, 0.19)"
    },
    cx: -257.82,
    cy: 265.405,
    rx: 62.801,
    ry: 62.801
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(41, 103, 102)",
      strokeWidth: 6,
      fill: "rgb(248, 248, 248)"
    },
    cx: -251.454,
    cy: 260.025,
    rx: 62.801,
    ry: 62.801
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 7,
      fill: "rgb(197, 227, 201)"
    },
    cx: -251.454,
    cy: 260.025,
    rx: 30.75,
    ry: 30.75
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(41, 102, 102)",
      strokeLinecap: "round",
      fill: "none",
      strokeWidth: 9
    },
    d: "M -266.918 255.703 L -249.612 271.256 L -212.152 235.111"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSubscriptionStatusActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/subscription-status-active.45a2ccae214a15e1b357f5d407d3bf4a.svg";